export const actions = {
  user: {
    name: 'setUserName',
    online: 'updateOnlineUsers'
  }
}
